import { ModalDialog } from '@/scripts/theme/modal-dialog'
import { currentTargetRequired, getAttributeOrThrow, qsRequired } from '@/scripts/core/global'
import { getDOMCart, getSectionHTMLForResource, renderRawHTMLToDOM } from '@/scripts/core/cart-functions'


type CartUpsellInitData = {
	continueToCartButton: HTMLButtonElement
	dynamicContent: HTMLElement
}
export class CartUpsell extends ModalDialog {
	static override htmlSelector = 'dynamic-cart-upsell'
	initData?: CartUpsellInitData

	constructor() {
		super()
		this.initData = this.getInitData()
		this.initData?.continueToCartButton.addEventListener('click', this.continueToCart.bind(this))
	}

	continueToCart() {
		this.hide(true)
		window.setTimeout(() => {
			getDOMCart()?.open()
		}, 3)
	}

	reinit() {
		this.initData = this.getInitData()
		this.initData?.continueToCartButton.addEventListener('click', this.continueToCart.bind(this))
		this.querySelectorAll('[id^="ModalClose-"]')?.forEach((closeButton) => {
			closeButton.addEventListener('click', this.hide.bind(this, false))
		})
	}

	async reloadAndOpen(productUrl: string, opener?: HTMLButtonElement, ) {
		const html = await getSectionHTMLForResource(productUrl, 'dynamic-cart-upsell')
		if (!html) {
			throw new Error('Failed to fetch upsell section HTML')
		}
		renderRawHTMLToDOM({
			sourceHTML: html,
			sourceSelector: 'dynamic-cart-upsell [data-dynamic-content]',
			destinationSelector: 'dynamic-cart-upsell [data-dynamic-content]',
		})

		this.reinit()

		if (opener) {
			this.openedBy = opener
		}
		this.show(opener)
		window.setTimeout(() => {
			window.Ucoast.mediaManager.loadAllInContainer(this)
		}, 1)
	}

	getInitData() {
		try {
			return {
				continueToCartButton: qsRequired<HTMLButtonElement>('[data-continue-to-cart]', this),
				dynamicContent: qsRequired('[data-dynamic-content]', this)
			}
		} catch(e) {
			console.warn('CartUpsell: missing required data attributes', e)
			return undefined
		}
	}
}
